export default __webpack_public_path__ + "static/media/king-sign.8278cbb9.svg";